/* eslint-disable no-unused-vars */
import axios from "axios";
import { getUrl } from "@/common/config";
class ApplicationsApi {
  constructor(organizationCode) {
    // Get org id from passed in var
    this.organizationCode = organizationCode || localStorage.organizationCode;
    this.url = getUrl();
  }

  get organizationCode() {
    if (!this.orgCode) {
      this.organizationCode = localStorage.organizationCode;
    }
    return this.orgCode;
  }

  set organizationCode(newValue) {
    this.orgCode = newValue || localStorage.organizationCode;
  }

  /**
   * Get applications machines
   * Params:
   * @param {int} skip
   * @param {int} limit
   * @returns {Array} promise with machine applications
   */
  async getMachinesApplications() {
    const organizationCode = this.organizationCode;
    const params = {
      skip: 0,
      limit: 100,
      organizationCode
    };

    return axios.get(`${this.url}/machineapplications`, { params }).then(response => {
      return response.data.result;
    });
  }

  /**
   * Get applications by id
   * Params:
   * @param {string} id
   * @returns {Array} promise with applications
   */
  async getMachineApplicationById(id) {
    return axios.get(`${this.url}/machineapplications/${id}`).then(response => {
      return response.data.result;
    });
  }

  /**
   * Get all applications
   * @returns {Array} promise with applications
   */
  async getApplications() {
    return axios.get(`${this.url}/applications`).then(response => {
      return response.data.result;
    });
  }
}

export const applicationsApi = new ApplicationsApi();
